


































































import {Component, Mixins, Prop} from 'vue-property-decorator';
import {NaverClaimData} from 'ncp-api-supporter';
import AmountMixin from '@/components/claim/popup/mixins/AmountMixin';

@Component
export default class NaverPayReturnHold extends Mixins(AmountMixin) {
  @Prop({required: true})
  private naverExternalData!: NaverClaimData;
}
